var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-list-cell-renderer-contact"},[_c('div',[_vm._v(_vm._s(_vm.contactName))]),(_vm.gpMqIsMobile)?_c('div',[_vm._v(_vm._s(_vm.contactPhone))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }